import { ptax } from '@/proto/proto';

export const REMEMBER_ME = 'pcrm';
export const ACCESS_TOKEN = 'pcat';
export const REFRESH_TOKEN = 'pcrt';

export const FORMAT_DATE_GENERAL_EXCEPT_TIME = 'YYYY-MM-DD';
export const FORMAT_DATE_GENERAL_EXCEPT_SECOND = 'YYYY-MM-DD HH:mm';
export const FORMAT_DATE_GENERAL = 'YYYY-MM-DD HH:mm:ss';

export const FORMAT_DATE_SHORTEN_KR = 'YYYY년 M월 D일';
export const FORMAT_DATE_EXCEPT_SECOND_KR = 'YYYY년 M월 D일 H시 m분';
export const FORMAT_DATE_EXCEPT_YEAR_SECOND_KR = 'M월 D일 H시 m분';
export const FORMAT_DATE_FORMAL_KR = 'YYYY년 M월 D일 HH:mm';

export const FORMAT_DATE_SIMPLE_EXCEPT_YEAR_TIME = 'YYYY.MM.DD';

export const PATH_ROOT = '/';

/** @see App */
export const PATH_MAIN = PATH_ROOT;

/** @see AuthRoute */
export const PATH_AUTH = '/auth';

/** @see LoginPage */
export const PATH_AUTH_LOGIN = `${PATH_AUTH}/login`;

/** @see SignupPage */
export const PATH_AUTH_SIGNUP = `${PATH_AUTH}/signup`;

export const PATH_AUTH_CHECK = `${PATH_AUTH}/check`;
export const PATH_AUTH_FORGOT_ACCOUNT = `${PATH_AUTH}/forgot-account`;
export const PATH_AUTH_FORGOT_PASSWORD = `${PATH_AUTH}/forgot-password`;

export const PATH_PROFILE = '/profile';

export const PATH_CHANGE_PASSWORD = '/change-password';

export const PATH_COMPANY = '/company';
export const PATH_COMPANY_CAR = `${PATH_COMPANY}/car`;
export const PATH_COMPANY_CAR_WRITE = `${PATH_COMPANY_CAR}/write`;
export const PATH_COMPANY_CAR_IMPORT = `${PATH_COMPANY_CAR}/import`;
export const PATH_COMPANY_CAR_INFO = `${PATH_COMPANY_CAR}/:companyCarId`;

export const PATH_CONTRACT = '/contract';
export const PATH_CONTRACT_WRITE = `${PATH_CONTRACT}/write`;
export const PATH_CONTRACT_IMPORT = `${PATH_CONTRACT}/import`;
export const PATH_CONTRACT_INFO = `${PATH_CONTRACT}/:contractId`;

export const PATH_TAX = '/tax-notice';

export const PATH_TAX_NOTICE = `${PATH_TAX}`;
export const PATH_TAX_NOTICE_DETAIL = (taxNotice?: ptax.IPbTaxNotice) => `${PATH_TAX_NOTICE}/${taxNotice?.base?.id ?? ':taxId'}`;
export const PATH_TAX_NOTICE_UPLOAD = `${PATH_TAX_NOTICE}/upload`;
export const PATH_TAX_NOTICE_LIST = `${PATH_TAX_NOTICE}/list`;
export const PATH_TAX_NOTICE_DOCUMENT = `${PATH_TAX_NOTICE}/:objectionId/:itemId/document`;

export const PATH_TAX_CHANGE = `${PATH_TAX}/change`;
export const PATH_TAX_CHANGE_INFO = (id: string, itemId: number | protobuf.Long) => `${PATH_TAX_NOTICE}/${id}/${itemId}/document`;
export const PATH_TAX_CHANGE_LIST = (id: string) => `${PATH_TAX_NOTICE}/${id}/document`;
export const PATH_TAX_CHANGE_HISTORY = `${PATH_TAX_CHANGE}/history`;

export const PATH_SERVICE = '/service';
export const PATH_SERVICE_MANAGE = `${PATH_SERVICE}/manage`;
export const PATH_SERVICE_USAGE = `${PATH_SERVICE}/usage`;
export const PATH_SERVICE_MANAGE_ACCOUNT = `${PATH_SERVICE_MANAGE}/account`;
export const PATH_SERVICE_MANAGE_API = `${PATH_SERVICE_MANAGE}/api`;
export const PATH_SERVICE_MANAGE_FORM = `${PATH_SERVICE_MANAGE}/form`;

export const PATH_USER = '/user';

export const PATH_ADMIN = '/admin';

export const PATH_MANAGE = '/manage';

export const PATH_TERMS = '/terms';
export const PATH_TERMS_OF_SERVICE = `${PATH_TERMS}/service`;
export const PATH_TERMS_OF_PRIVACY = `${PATH_TERMS}/privacy`;

export const API_AUTH = '/auth';
export const API_AUTH_CHECK = `${API_AUTH}/check`;
export const API_AUTH_CODE = `${API_AUTH}/code`;
export const API_AUTH_CONFIRM = `${API_AUTH}/confirm`;
export const API_AUTH_CHANGE_PASSWORD = `${API_AUTH}/pass`;
export const API_AUTH_FIND = `${API_AUTH}/find`;
export const API_AUTH_SIGNUP = `${API_AUTH}/signup`;
export const API_AUTH_LOGIN = `${API_AUTH}/login`;

export const API_COMPANY = '/company';
export const API_COMPANY_CAR = `${PATH_COMPANY}/car`;
export const API_COMPANY_CAR_INFO = (id: string) => `${PATH_COMPANY}/car/${id}`;

export const API_CONTRACT = '/contract';
export const API_CONTRACT_ADD = `${API_CONTRACT}/add`;
export const API_CONTRACT_UPLOAD = `${API_CONTRACT}/upload`;

export const API_TAX_NOTICE = '/tax-notice';
export const API_TAX_NOTICE_INFO = (id: number) => `${API_TAX_NOTICE}/${id}`;
export const API_TAX_CONTRACT_UPLOAD = `${API_TAX_NOTICE}/contract/upload`;
export const API_TAX_NOTICE_SEND = `${API_TAX_NOTICE}/send`;
export const API_TAX_NOTICE_EXCEPT = `${API_TAX_NOTICE}/except`;
export const API_TAX_CHANGE_REQUEST_HISTORY = `${API_TAX_NOTICE}/requested`;
export const API_TAX_CHANGE_REQUEST_INFO = (id: number) => `${API_TAX_NOTICE}/change/${id}`;
export const API_TAX_CHANGE_REQUEST_REFUND = `${API_TAX_NOTICE}/fax/refund`;
export const API_TAX_CHANGE_REQUEST_RESEND = `${API_TAX_NOTICE}/fax/resend`;
export const API_OBJECTION_RECOGNIZE = `${API_TAX_NOTICE}/recognize`;
export const API_OBJECTION_SEARCH = `${API_TAX_NOTICE}/search`;
export const API_OBJECTION_EDIT = `${API_TAX_NOTICE}/edit`;
export const API_TAX_NOTICE_REMAIN_LIST = `${API_TAX_NOTICE}/remain`;
export const API_TAX_CHANGE_SEND = `${API_TAX_NOTICE}/send`;
export const API_TAX_CHANGE_SEND_AUTO = `${API_TAX_CHANGE_SEND}/auto`;
export const API_TAX_CHANGE_SEND_FAX = `${API_TAX_CHANGE_SEND}/fax`;
export const API_TAX_CHANGE_SEND_GOV = `${API_TAX_CHANGE_SEND}/govdoc`;

export const API_TAX_CONTACT = '/tax/contact';

const PADDED_COMPANY_ID = (companyId: string) => companyId.padStart(6, '0');

export const IMAGE_PATH_TAX_CONTRACT = (companyId: number, objection: ptax.IPbTaxNotice | undefined | null) =>
  `${process.env.REACT_APP_IMAGE_SERVER}/${objection?.contractFileName}`;

export const IMAGE_PATH_OBJECTION = (companyId: number, objection: ptax.IPbTaxNotice | undefined | null) =>
  `${process.env.REACT_APP_IMAGE_SERVER}/tax-notice/${objection?.fileName}`;

export const IMAGE_PATH_TAX_NOTICE = (companyId: number, taxNotice: ptax.IPbTaxNotice | undefined | null) =>
  `${process.env.REACT_APP_IMAGE_SERVER}/${taxNotice?.fileName}`;

export const IMAGE_PATH_TAX_CHANGE = (companyId: number, taxNotice: ptax.IPbTaxNotice | undefined | null) =>
  `${process.env.REACT_APP_IMAGE_SERVER}/${taxNotice?.changeFileName}`;

export const IMAGE_PATH_COMPANY_LICENSE = (companyId: number, fileName: string) => `${process.env.REACT_APP_IMAGE_SERVER}/${fileName}`;

export const IMAGE_PATH_COMPANY_STAMP = (companyId: number, fileName: string) => `${process.env.REACT_APP_IMAGE_SERVER}/${fileName}`;

export const GENERAL_FILE_PATH = (fileName: string) => `${process.env.REACT_APP_IMAGE_SERVER}/general/${fileName}`;
